 import { ChangeDetectorRef, Component, ElementRef, Renderer2, ViewContainerRef } from '@angular/core';
import { AuthData } from "sharedFeatures/sharedModels";
import { WindowComponent } from "sharedFeatures/window";
import { NewCompanyWinBodyComponent } from './new-company-win-body.component';

@Component({
    selector: 'new-company-win',
    templateUrl: '../window/window.component.html',
    styleUrls: ['../window/window.component.less']
})
 export class NewCompanyWin extends WindowComponent {

     constructor(element: ElementRef,
         r: Renderer2,
         viewContainerRef: ViewContainerRef,
         chDet: ChangeDetectorRef
     ) {

         super(element, r, viewContainerRef, chDet);

         this.width = -1;
         this.height = -1;

         this.showClose = false;

         this.title = '';

         this.cornerRadius = 0;

         this.isModal = true;

         this.topMargin = 20;

         this.windowContentBody = NewCompanyWinBodyComponent;
     }

     getBodyComponent(): NewCompanyWinBodyComponent {

         return <NewCompanyWinBodyComponent>super.getBodyComponent();

     }

     public isTeamOwner: boolean = false;

     authData: AuthData = new AuthData();
     public companyWinHeight: number = 0;

     public setAuthData(data: AuthData): void {
         this.authData = data;

         this.isTeamOwner = (this.authData.teamOwnerId == 0 || this.authData.teamOwnerId == this.authData.userID);
     }
 }
